import * as loadingStates from '@coconut/constants/loadingState';

export const types = {
  FETCH_QUESTION_QUOTA: 'FETCH_QUESTION_QUOTA',
  FETCH_QUESTION_QUOTA_SUCCESS: 'FETCH_QUESTION_QUOTA_SUCCESS',
  FETCH_QUESTION_QUOTA_FAILED: 'FETCH_QUESTION_QUOTA_FAILED',
};

export const fetchQuestionQuota = () => ({
  type: types.FETCH_QUESTION_QUOTA,
});

export const fetchQuestionQuotaSuccess = ({
  qaQuota,
  writingQuota,
  isPaidUser,
}) => ({
  type: types.FETCH_QUESTION_QUOTA_SUCCESS,
  payload: {
    qaQuota,
    writingQuota,
    isPaidUser,
  },
});

export const fetchQuestionQuotaFailed = (errorMessage) => ({
  type: types.FETCH_QUESTION_QUOTA_FAILED,
  payload: {
    errorMessage,
  },
});

const initialState = {
  status: loadingStates.EMPTY,
  errorMessage: '',
  qaQuota: 0,
  writingQuota: 0,
  totalQuota: 0,
  isPaidUser: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_QUESTION_QUOTA:
      return {
        ...state,
        status: loadingStates.LOADING,
      };
    case types.FETCH_QUESTION_QUOTA_SUCCESS:
      return {
        ...state,
        status: loadingStates.READY,
        qaQuota: action.payload.qaQuota,
        writingQuota: action.payload.writingQuota,
        totalQuota: action.payload.qaQuota + action.payload.writingQuota,
        isPaidUser: action.payload.isPaidUser,
      };
    case types.FETCH_QUESTION_QUOTA_FAILED:
      return {
        ...state,
        status: loadingStates.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return {
        ...state,
      };
  }
}

export const getQAQuota = (state) => state.questionQuota.qaQuota;
export const getWritingQuota = (state) => state.questionQuota.writingQuota;
export const getTotalQuota = (state) => state.questionQuota.totalQuota;
export const getIsPaidUser = (state) => state.questionQuota.isPaidUser;



// WEBPACK FOOTER //
// ./src/services/redux/questionQuota.js